import api from "./api.ts";

export async function acceptPartnerOwnerInvitation(
  invitationCode: string,
  password: string
) {
  const response = await api.post("/partner/accept-partnerOwner-invitation", {
    invitationCode,
    password,
  });
  return response.data;
}

export async function acceptPartnerUserInvitation(
  partnerNumber: string,
  invitationCode: string,
  password: string
) {
  const response = await api.post("/partner/accept-partnerUser-invitation", {
    partnerNumber,
    invitationCode,
    password,
  });
  return response.data;
}
